import _Promise from 'babel-runtime/core-js/promise';
import jsonp from 'jsonp';

function appendTimeStamp(url) {
  var _t = '_t=' + new Date().getTime();
  if (url.indexOf('?') > -1) {
    url = url + '&' + _t;
  } else {
    url = url + '?' + _t;
  }
  return url;
}
/**
 * 发起一个 jsonp 请求
 * @param {string} url 请求 url
 * @param {object} params 请求参数
 * @returns {object} 请求结果
 */
export default function (url, params) {
  return new _Promise(function (resolve, reject) {
    jsonp(appendTimeStamp(url), params, function (err, data) {
      if (err) return reject(err);
      resolve(data);
    });
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/common-cpq-constraint/es/jsonp.js
// module id = 172
// module chunks = 0